import '../../css/style.scss'
import {UIWHeaderController} from '../ui_html/header/UIWHeaderController.ts'
import {UISidebarController} from '../ui_html/sidebar/UISidebarController.ts'
import {EntryShared} from '../../../shared/scripts/EntryShared.ts'
import {UISingletonScrollController} from '../../../shared/scripts/ui_scroll_controller/UISingletonScrollController.ts'
import {EntrySingletonPageShared} from '../../EntrySingletonPageShared.ts'

void init()

async function init() {
    EntryShared.initializeAudio()

    await EntryShared.initializeEntry()

    const headerController = new UIWHeaderController()
    new UISidebarController()

    new UISingletonScrollController()

    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
    EntryShared.sendPageVisitAnalyticEvent()
}
